export const schema = 'schema must be an object with a type property';
export const notype = 'type Property is missing';
export const noNameOrField = 'name and/or field-property is mandatory';
export const typeunknown = (type: string) => `type Property is unknown: "${type}"`;
export const requiredpropmissing = (prop: string) => `required Property is missing: "${prop}"`;
export const unknownprop = (prop: string) => `unknown Property: "${prop}"`;
export const wrongproptype = (prop: string, expected: string) => `Type of Property "${prop}" is wrong: expected "${expected}"`;
export const wrongproptypearray = (prop: string, expected: string) => `Type of one Array-Element in Property "${prop}" is wrong: expected "${expected}"`;
export const wrongproptypearraychilren = `Select Option Items must have "label" and "value" keys`;
export const doubleName = (name: string) => `Name "${name}" is more than once used`;
export const doubleField = (name: string) => `Field "${name}" is more than once used`;
export const fieldName = (name: string) => `Field "${name}" may not contain spaces`;
export const arraempty = (prop: string) => `Empty Array: "${prop}"`;
export const doublebp = (bp: string) => `Several of the same breakpoints in "cols" defined: "${bp}"`;

export const datatablenofields = 'Data-Table detailComponent contains no fields';
export const datatableindatatable = 'Nested Data-Table in Data-Table is not supported';
export const datatablenosummary = 'summaryCard function is missing  in datatable cardview';

//styles